interface ProgressBarProps {
  /** Items visibles déjà répondus. */
  answered: number;
  /** Items visibles au total (hors notes). */
  total: number;
}

/**
 * Barre de progression sobre. RGAA :
 * - `role="progressbar"` + `aria-valuenow/min/max` + `aria-valuetext`.
 * - Couleur + libellé texte (jamais couleur seule).
 * - Microcopie de réassurance permanente.
 */
export function ProgressBar({ answered, total }: ProgressBarProps) {
  const pct = total > 0 ? Math.round((answered / total) * 100) : 0;
  const safePct = Math.min(100, Math.max(0, pct));

  return (
    <div className="space-y-2">
      <div
        className="flex items-center justify-between text-sm text-text-muted"
        aria-hidden="true"
      >
        <span>
          {answered} / {total} questions
        </span>
        <span>{safePct} %</span>
      </div>
      <div
        role="progressbar"
        aria-valuenow={safePct}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuetext={`${answered} questions répondues sur ${total}`}
        aria-label="Progression du questionnaire"
        className="h-2 w-full bg-surface-2 rounded-full overflow-hidden"
      >
        <div
          className="h-full bg-accent transition-all"
          style={{ width: `${safePct}%` }}
        />
      </div>
      <p className="text-xs text-text-muted">
        Vous pouvez interrompre et reprendre sur cet appareil. Aucune donnée
        n'est envoyée tant que vous n'avez pas validé l'envoi final.
      </p>
    </div>
  );
}
